// extracted by mini-css-extract-plugin
export default {"input":"phone-login_input__xctvj","content":"phone-login_content__lUWU+"};